import { NgClass, UpperCasePipe } from '@angular/common';
import { Component, DestroyRef, effect, inject, input, signal, Signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CardLoaderModule } from '@iot-platform/iot-platform-ui';
import { Filter } from '@iot-platform/models/common';
import { Dashboard, DashboardWidget } from '@iot-platform/models/dashboards';
import { TranslatePipe } from '@ngx-translate/core';
import type { Options } from 'highcharts';
import { HighchartsChartComponent } from 'highcharts-angular';
import { DashboardsHelper } from '../../helpers/dashboards.helper';
import { DashboardsService } from '../../services/dashboards.service';

@Component({
  imports: [FlexLayoutModule, CardLoaderModule, HighchartsChartComponent, NgClass, TranslatePipe, UpperCasePipe],
  selector: 'iot-platform-feature-dashboards-dashboards-shell',
  templateUrl: './dashboards-shell.component.html',
  styleUrl: './dashboards-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [DashboardsHelper]
})
export class DashboardsShellComponent {
  filters: Signal<Filter[]> = input<Filter[]>([]);
  dashboard: Signal<Dashboard | undefined> = input<Dashboard | undefined>(undefined);

  mainChartOptions: { [widgetId: string]: Options } = {};
  loading: WritableSignal<boolean> = signal(true);

  dashboardsService = inject(DashboardsService);
  helper = inject(DashboardsHelper);
  destroyRef = inject(DestroyRef);

  constructor() {
    effect(() => {
      if (this.dashboard()) {
        this.loading.set(true);
        this.dashboardsService
          .getDashboardData(this.dashboard(), this.filters())
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((widgetData: DashboardWidget[]) => {
            this.loading.set(false);
            widgetData.forEach((widget) => (this.mainChartOptions[widget.id] = this.helper.getHighchartsOptions(widget)));
          });
      } else {
        this.loading.set(false);
      }
    });
  }
}
